var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5090_16261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1707 13.3359C18.7292 13.3359 18.3738 13.6914 18.3738 14.1328V17.9766H2.42065V14.1328C2.42065 13.6914 2.06519 13.3359 1.62378 13.3359C1.18237 13.3359 0.826904 13.6914 0.826904 14.1328V18.7734C0.826904 19.2148 1.18237 19.5703 1.62378 19.5703H19.1707C19.6121 19.5703 19.9675 19.2148 19.9675 18.7734V14.1328C19.9675 13.6914 19.6121 13.3359 19.1707 13.3359Z",
    fill: "#A93E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81131 14.2812C10.2605 14.7344 10.8113 14.4844 10.9793 14.2812L15.5613 9.35156C15.8621 9.02734 15.8426 8.52344 15.5183 8.22266C15.1941 7.92187 14.6902 7.94141 14.3933 8.26562L11.1941 11.707V1.34766C11.1941 0.90625 10.8387 0.550781 10.3972 0.550781C9.95584 0.550781 9.60037 0.90625 9.60037 1.34766V11.7109L6.40115 8.26953C6.10037 7.94531 5.59647 7.92969 5.27225 8.22656C4.94803 8.52734 4.9324 9.03125 5.22928 9.35547L9.81131 14.2812V14.2812Z",
    fill: "#A93E71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5090_16261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.397217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPink);
export default __webpack_public_path__ + "static/media/download-pink.dfef281ba0d7d81705f531575509aed5.svg";
export { ForwardRef as ReactComponent };